import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Menu, Button, message, Card } from 'antd';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { draftToolbarOptions } from '../utils/globals';

import MUTATION from '../graphql/mutations/saveFactsheetAdditionalDetailsMutation.graphql';

const names = {
  company_background: 'Company Background',
  promoters_background: 'Promoters Background',
  project_background: 'Current Project Background',
  ecosystem_brief: 'Ecosystem Brief',
  remarks: 'Other Observations & Comments',
};

class AdditionalDetailsForms extends Component {
  state = {
    selectedKey: 'company_background',
    editorStates: {
      company_background: EditorState.createEmpty(),
      promoters_background: EditorState.createEmpty(),
      project_background: EditorState.createEmpty(),
      ecosystem_brief: EditorState.createEmpty(),
      remarks: EditorState.createEmpty(),
    },
    submittingForm: false,
  };

  componentWillMount() {
    const { customerAdditionalDetails } = this.props;
    const newEditorStates = { ...this.state.editorStates };
    if (customerAdditionalDetails.company_background) {
      newEditorStates.company_background = EditorState.createWithContent(convertFromRaw(JSON.parse(customerAdditionalDetails.company_background)));
    }
    if (customerAdditionalDetails.promoters_background) {
      newEditorStates.promoters_background = EditorState.createWithContent(convertFromRaw(JSON.parse(customerAdditionalDetails.promoters_background)));
    }
    if (customerAdditionalDetails.project_background) {
      newEditorStates.project_background = EditorState.createWithContent(convertFromRaw(JSON.parse(customerAdditionalDetails.project_background)));
    }
    if (customerAdditionalDetails.ecosystem_brief) {
      newEditorStates.ecosystem_brief = EditorState.createWithContent(convertFromRaw(JSON.parse(customerAdditionalDetails.ecosystem_brief)));
    }
    if (customerAdditionalDetails.remarks) {
      newEditorStates.remarks = EditorState.createWithContent(convertFromRaw(JSON.parse(customerAdditionalDetails.remarks)));
    }
    this.setState({
      editorStates: newEditorStates,
    });
  }

  onEditorStateChange = (editorState, key) => {
    const newEditorStates = { ...this.state.editorStates };
    newEditorStates[key] = editorState;
    this.setState({
      editorStates: newEditorStates,
    });
  };

  getEditor = () => {
    const { editorStates, selectedKey } = this.state;
    return (
      <Editor
        wrapperClassName="rdw-wrapper"
        editorClassName="rdw-editor"
        toolbarClassName="rdw-toolbar"
        editorState={editorStates[selectedKey]}
        onEditorStateChange={(editorState) => { this.onEditorStateChange(editorState, selectedKey); }}
        toolbar={draftToolbarOptions}
      />
    );
  };

  handleSubMenuClick = (e) => {
    this.setState({
      selectedKey: e.key,
    });
  };

  handleSave = () => {
    this.setState({
      submittingForm: true,
    });
    const { customer_id } = this.props;
    const { editorStates } = this.state;
    this.props.mutate({
      variables: {
        customer_id,
        company_background: JSON.stringify(convertToRaw(editorStates.company_background.getCurrentContent())),
        promoters_background: JSON.stringify(convertToRaw(editorStates.promoters_background.getCurrentContent())),
        project_background: JSON.stringify(convertToRaw(editorStates.project_background.getCurrentContent())),
        ecosystem_brief: JSON.stringify(convertToRaw(editorStates.ecosystem_brief.getCurrentContent())),
        remarks: JSON.stringify(convertToRaw(editorStates.remarks.getCurrentContent())),
      },
      // update: (cache, { data: { newCustomerBankAccount } }) => {
      //   const data = cache.readQuery({
      //     query: STORE_QUERY,
      //     variables: { customer_id },
      //   });
      //   if (!Array.isArray(data.customerBankAccounts)) data.customerBankAccounts = [];
      //   data.customerBankAccounts.push(newCustomerBankAccount);
      //   cache.writeQuery({ query: STORE_QUERY, variables: { customer_id }, data });
      // },
    })
      .then(() => {
        this.setState({
          submittingForm: false,
        });
        message.success('Success!');
      })
      .catch((mutateErr) => {
        console.log(mutateErr);
        this.setState({
          submittingForm: false,
        });
        message.error(mutateErr.message);
      });
  };

  render() {
    return (
      <Card title="Factsheet - Additional Details" bordered={false} className="ec-card">
        <Menu
          onClick={this.handleSubMenuClick}
          selectedKeys={[this.state.selectedKey]}
          mode="horizontal"
        >
          <Menu.Item key="company_background">
            {names.company_background}
          </Menu.Item>
          <Menu.Item key="promoters_background">
            {names.promoters_background}
          </Menu.Item>
          <Menu.Item key="project_background">
            {names.project_background}
          </Menu.Item>
          <Menu.Item key="ecosystem_brief">
            {names.ecosystem_brief}
          </Menu.Item>
          <Menu.Item key="remarks">
            {names.remarks}
          </Menu.Item>
        </Menu>

        {
          this.getEditor()
        }

        <br />
        <Button type="primary" loading={this.state.submittingForm} onClick={this.handleSave}>Save All</Button>
      </Card>
    );
  }
}

AdditionalDetailsForms.propTypes = {
  customerAdditionalDetails: PropTypes.shape({
    company_background: PropTypes.string,
    promoters_background: PropTypes.string,
    project_background: PropTypes.string,
    ecosystem_brief: PropTypes.string,
    remarks: PropTypes.string,
  }).isRequired,
  customer_id: PropTypes.string.isRequired,
  mutate: PropTypes.func.isRequired,
};

export default graphql(MUTATION)(AdditionalDetailsForms);



// WEBPACK FOOTER //
// ./src/forms/AdditionalDetailsForms.jsx